import { select, call, put, takeLatest } from 'redux-saga/effects';
import swal from 'sweetalert';
import {
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_VOICE_PROFILE_REQUEST,
  UPDATE_VOICE_PROFILE_SUCCESS,
  UPDATE_VOICE_PROFILE_FAILURE,
  FETCH_VOICE_PROFILE_REQUEST,
  FETCH_VOICE_PROFILE_SUCCESS,
  FETCH_VOICE_PROFILE_FAILURE,
  fetchVoiceProfile,
} from './actions';
import { LOGOUT } from '../Main/actions';
import { post, get } from '../../utils/api';
import { tokenSelector } from '../Main/reducer';
import { handleApiError } from '../../utils/handleApiError';

function* updatePassword({ payload }) {
  try {
    const token = yield select(tokenSelector);
    yield call(
      post,
      `/reset-password`,
      {
        currentPassword: payload.currentPassword,
        newPassword: payload.newPassword,
      },
      token
    );
    yield put({ type: UPDATE_PASSWORD_SUCCESS });
    yield call(swal, 'Success', 'Password updated successfully', 'success');
    yield put({ type: LOGOUT });
    yield call([window.location, 'replace'], '/login');
  } catch (error) {
    yield handleApiError(error, UPDATE_PASSWORD_FAILURE);
  }
}

function* updateVoiceProfile({ payload }) {
  try {
    const token = yield select(tokenSelector);
    yield call(
      post,
      `/voice-profile/update`,
      {
        language: payload.lang,
        vocabulary: payload.vocabulary,
      },
      token
    );
    yield put({ type: UPDATE_VOICE_PROFILE_SUCCESS });
    yield call(
      swal,
      'Success',
      'Voice profile updated successfully',
      'success'
    );
    yield put(fetchVoiceProfile());
  } catch (error) {
    yield handleApiError(error, UPDATE_VOICE_PROFILE_FAILURE);
  }
}

function* fetchVoiceProfileSaga() {
  try {
    const token = yield select(tokenSelector);
    const response = yield call(get, '/voice-profile/get', token);
    const { language, vocabulary } = response.data.voiceProfile;
    yield put({
      type: FETCH_VOICE_PROFILE_SUCCESS,
      payload: {
        lang: language,
        vocabulary: vocabulary,
      },
    });
  } catch (error) {
    yield handleApiError(error, FETCH_VOICE_PROFILE_FAILURE);
  }
}

export default [
  takeLatest(UPDATE_PASSWORD_REQUEST, updatePassword),
  takeLatest(UPDATE_VOICE_PROFILE_REQUEST, updateVoiceProfile),
  takeLatest(FETCH_VOICE_PROFILE_REQUEST, fetchVoiceProfileSaga),
];
